import RegMark from '../ui/RegMark'

/* ==========================================================================
   Chrome under a film: the cycle ruler (a dimension line split into one
   third per station, its orange fill written by the film writer) and the
   stations. A plate carries the full title block (name and text per
   station); a tile carries the station names only.
   ========================================================================== */

const NODES = [0, 1, 2]

/**
 * The cycle as a dimension line. `beats` are the contact moments, already
 * placed on the line (0..1); `cycle` is the word at its start, or null.
 */
export function Ruler({ cycle, lang, beats }) {
  return (
    <div className="pp__ruler" aria-hidden="true">
      {cycle && <span className="pp__ruler-word legend">{cycle.toLocaleUpperCase(lang)}</span>}
      <span className="pp__ruler-line" />
      <span className="pp__ruler-fill" />
      {beats.map((at) => (
        <span key={at} className="pp__ruler-beat" style={{ '--at': at }} />
      ))}
      {NODES.map((i) => (
        <span key={i} className="pp__ruler-node" data-node={i} style={{ '--at': i / NODES.length }}>
          <RegMark className="pp__node-mark" size={12} />
        </span>
      ))}
    </div>
  )
}

/**
 * The stations, the live one at full contrast. With `detail` each is a
 * heading and its text (the plate's title block); without, a name in legend
 * type under its third of the ruler (a tile).
 */
export function Stations({ stations, detail }) {
  return (
    <ol className={detail ? 'pp__stations' : 'pp__stations pp__stations--names'}>
      {stations.map((station) => (
        <li className="pp__station" key={station.name}>
          {detail ? (
            <>
              <h3 className="pp__station-name">
                <RegMark />
                <span className="pp__name">
                  {station.name}
                  <span className="pp__ghost" aria-hidden="true">
                    {station.name}
                  </span>
                </span>
              </h3>
              <p>{station.text}</p>
            </>
          ) : (
            <span className="pp__station-name legend">{station.name}</span>
          )}
        </li>
      ))}
    </ol>
  )
}
